import { Head } from '@ecommerce/nest-ssr/components';
import favicon from 'assets/images/favicon.svg';
import AppleTouchIcon from 'assets/public/apple-touch-icon.png';
import AdConfig from 'components/ads/ad-config';
import DataLayer from 'components/datalayer/datalayer';
import Environment from 'components/environment';
import GtmBody from 'components/gtm/gtm-body';
import GtmHead from 'components/gtm/gtm-head';
import { useSeo } from 'hooks/use-seo';
import React from 'react';
import StructuredData from '../structured-data/structured-data';
import { Modals } from 'components/modal/modals';
import { SLOT_SCREENING_BACKGROUND } from 'components/ads/ad-slot/ad-defs';
import AdSlot from 'components/ads/ad-slot';

import './main-layout.base.scss';

type MainLayoutProps = {
    children: React.ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    const seo = useSeo();
    const gtmKey = 'KZBQXM5K';

    return (
        <main>
            <Head>
                <meta charSet="UTF-8" />
                <meta name="theme-color" content="#084691" />
                <meta name="google-site-verification" content="2QdbT2lrmu-I_UOPJRXgCjm5PEXrQVx1IDj5f6iTJeU" />
                <link rel="shortcut icon" href={favicon} />
                <link rel="manifest" href="/manifest.json?v1.0.1" />
                <link rel="apple-touch-icon" href={AppleTouchIcon} />
                <title>
                    {seo.title}
                </title>
                <meta name="keywords" content={seo.keywords} />
                <meta name="description" content={seo.description} />

                <meta property="og:title" content={seo.title} />
                <meta property="og:locale" content="pl_PL" />
                <meta property="og:description" content={seo.description} />
                <meta property="og:url" content={`https://cenojad.pl${seo.og.url}`} />
                <meta property="og:site_name" content="Cenojad.pl" />
                <meta name="image" property="og:image" content={seo.og.image} />
                <meta property="og:type" content={seo.og.type} />
                <link rel="canonical" href={seo.canonical} />
                <AdConfig />
                <GtmHead gtmKey={gtmKey} />
            </Head>
            <AdSlot name={SLOT_SCREENING_BACKGROUND} className="creation-screening-background" resizable={true} />
            {children}
            <Modals />
            <GtmBody gtmKey={gtmKey} />
            <DataLayer />
            <Environment />
            <script
                dangerouslySetInnerHTML={{
                    __html: 'if(navigator.userAgent.indexOf("MSIE ") > -1 '
                        + '|| navigator.userAgent.indexOf("Trident/") > -1) '
                        + '{var elem = document.createElement("div"); '
                        + 'var a = document.createElement("a"); a.href="/zalecane-przegladarki"; '
                        + 'var text = document.createTextNode("Sprawdź jakie przeglądarki zapewnią '
                        + 'Ci pełne bezpieczeństwo i wygodę korzystania z naszego serwisu");'
                        + ' a.appendChild(text);elem.style.cssText = "width: 100%; height: 50px;'
                        + ' background: orange; color: white; display: flex; align-items: center;'
                        + ' justify-content: center;"; elem.innerText = "Używasz przestarzałej przeglądarki.";'
                        + ' elem.appendChild(a); document.body.insertBefore(elem, document.body.firstChild);'
                        + ' dataLayer.push({"not-supported-browser-bar": 1});}'
                }}
            />
            <StructuredData />
        </main>
    );
};

export default React.memo(MainLayout) as React.FC<MainLayoutProps>;
